/**
 * @author SwathiDivya Bhavaraju
 * @email [example@mail.com]
 * @create date 2023-01-04 10:18:33
 * @modify date 2023-01-04 10:18:33
 * @desc [description]
 */
import axios from 'axios';

/**
 * /userConsent/user get API
 * to get the Users CurrentPassword  */
export async function getUserConsent() {
  let responseFlag = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/userConsent/user`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        responseFlag = response.data.data;
      }
    })
    .catch((err) => console.log('get user consent java api error', err)); // eslint-disable-line no-console
  return responseFlag;
}

/**
 * /userConsent/user/userconsentType get API
 * to get the Users CurrentPassword  */
export async function updateUserConsent(userconsentType) {
  let responseFlag = null;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/userConsent/user/${userconsentType}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        responseFlag = response.data;
      }
    })
    .catch((err) => console.log('put user consent java api error', err)); // eslint-disable-line no-console
  return responseFlag;
}

export async function getCountryConsentType(countryId) {
  let res = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/userConsent/consent/type/${countryId}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        res = response.data.data;
      }
    })
    .catch((err) => console.log('get user consent java api error', err)); // eslint-disable-line no-console
  return res;
}

export async function getCountryConsent(consentId) {
  let res = {};
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/userConsent/consent`, consentId)
    .then((response) => {
      if (response.status === 200 && response.data) {
        res = response.data.data;
      }
    })
    .catch((err) => console.log('get user consent java api error', err)); // eslint-disable-line no-console
  return res;
}
export async function updateConsent(payload) {
  let responseFlag = null;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/userConsent/create`, payload)
    .then((response) => {
      if (response.status === 200 && response.data) {
        responseFlag = response.data;
      }
    })
    .catch((err) => console.log('put user consent java api error', err)); // eslint-disable-line no-console
  return responseFlag;
}
